class ProductCardBanner extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  template() {
    return `
      <div>
        <div>
          <slot></slot>
        </div>
      </div>
    `;
  }

  css() {
    return `
      :host {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      div {
        width: 100%;
        height: 100%;
        background: #fff;
        box-shadow: 0px 3px 10px 0px #81818126;
        border-radius: 10px;
      }

      div > div {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    `;
  }
}

customElements.define("x-product-card-banner", ProductCardBanner);
